module.exports = __webpack_public_path__ + "img/public/SiteIcons/steering-4.png?d936f37d";